Vendd.Scripts.load(function () {
    
    var loader = function () {

    };

    loader.prototype.init = function () {

        var wrapper = $('body');

        wrapper.append('<div class="js-inline-admin-loader"><div class="fancybox-slide fancybox-slide--current"><div class="fancybox-loading"></div></div></div>');

    };

    loader.prototype.show = function () {

        var wrapper = $('body');

        wrapper.addClass('js-inline-admin-loading');

    };

    loader.prototype.hide = function () {

        var wrapper = $('body');

        wrapper.removeClass('js-inline-admin-loading');

    };

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit.uiLoader = new loader();

});